import { Routes } from '@angular/router';
import { AdminComponent } from './features/admin/components/admin/admin.component';
import { isAdminGuard } from './core/guards/is-admin.guard';
import { isAuthGuard } from './core/guards/is-auth.guard';
import { isNotAuthGuard } from './core/guards/is-not-auth.guard';
import { PageNotFound404Component } from 'declarabid-library';
import { isTeacherGuard } from './core/guards/is-teacher.guard';
import { TeacherComponent } from './features/teacher/pages/teacher/teacher.component';
import { isDirectorGuard } from './core/guards/is-director.guard';
import { isLeaderGuard } from './core/guards/is-leader.guard';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  //Testing
  {
    path: 'testing',
    children: [],
  },

  //Register
  {
    path: 'register',
    loadComponent: () =>
      import('./features/intro/pages/intro.component').then(
        (c) => c.IntroComponent,
      ),
  },
  {
    path: 'register/:type',
    loadComponent: () =>
      import('./features/register/pages/register/register.component').then(
        (c) => c.RegisterComponent,
      ),
  },

  //Authentication
  {
    path: 'auth',
    canActivate: [isNotAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/pages/login/login.component').then(
            (c) => c.LoginComponent,
          ),
      },
    ],
  },

  //Teacher
  {
    path: 'teacher',
    canActivate: [isAuthGuard, isTeacherGuard],
    component: TeacherComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/my-profile/my-profile.component').then(
            (c) => c.MyProfileComponent,
          ),
      },
      {
        path: 'teacher-section/:id/:user_id',
        loadComponent: () =>
          import(
            './features/dashboard-declarant/components/declarant-section/declarant-section.component'
          ).then((c) => c.DeclarantSectionComponent),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import(
            './features/dashboard-teacher/pages/dashboard-teacher/dashboard-teacher.component'
          ).then((c) => c.DashboardTeacherComponent),
      },
      {
        path: 'feedback',
        loadComponent: () =>
          import(
            './features/feedback/pages/feedback-teacher/feedback-teacher.component'
          ).then((c) => c.FeedbackTeacherComponent),
      },

      {
        path: 'forms',
        loadComponent: () =>
          import('./features/forms/page/my-forms/my-forms.component').then(
            (c) => c.MyFormsComponent,
          ),
      },
      {
        path: 'teacher-section/:id',
        loadComponent: () =>
          import(
            './features/dashboard-declarant/components/declarant-section/declarant-section.component'
          ).then((c) => c.DeclarantSectionComponent),
      },
      {
        path: 'how-to-works',
        loadComponent: () =>
          import(
            './features/how-to-works/pages/how-to-works-teacher/how-to-works-teacher.component'
          ).then((c) => c.HowToWorksComponent),
      },
    ],
  },

  //Director
  {
    path: 'director',
    canActivate: [isAuthGuard, isDirectorGuard],
    component: TeacherComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/my-profile/my-profile.component').then(
            (c) => c.MyProfileComponent,
          ),
      },
      {
        path: 'feedback',
        loadComponent: () =>
          import(
            './features/feedback/pages/feedback-director/feedback-director.component'
          ).then((c) => c.FeedbackDirectorComponent),
      },

      {
        path: 'how-to-works',
        loadComponent: () =>
          import(
            './features/how-to-works/pages/how-to-work-director/how-to-work-director.component'
          ).then((c) => c.HowToWorkDirectorComponent),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import(
            './features/dashboard-director/pages/dashboard-director/dashboard-director.component'
          ).then((c) => c.DashboardDirectorComponent),
      },
      {
        path: 'director-section/:id',
        loadComponent: () =>
          import(
            './features/dashboard-declarant/components/declarant-section/declarant-section.component'
          ).then((c) => c.DeclarantSectionComponent),
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./features/forms/page/my-forms/my-forms.component').then(
            (c) => c.MyFormsComponent,
          ),
      },
    ],
  },

  //Admin
  {
    path: 'admin',
    canActivate: [isAuthGuard, isAdminGuard],
    component: AdminComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/my-profile/my-profile.component').then(
            (c) => c.MyProfileComponent,
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/projects/pages/projects/projects.component').then(
            (c) => c.ProjectsComponent,
          ),
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./features/projects/pages/projects/projects.component').then(
            (c) => c.ProjectsComponent,
          ),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/pages/home/home.component').then(
            (c) => c.HomeComponent,
          ),
      },
      {
        path: 'public-website',
        loadComponent: () =>
          import(
            './features/public-website/page/public-website/public-website.component'
          ).then((c) => c.PublicWebsiteComponent),
      },
      {
        path: 'institutions',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/institutions/pages/main-institutions/main-institutions.component'
              ).then((c) => c.MainInstitutionsComponent),
          },
          {
            path: 'add-institutions/:step',
            loadComponent: () =>
              import(
                './features/institutions/pages/add-institutions/add-institutions.component'
              ).then((c) => c.AddInstitutionsComponent),
          },
          {
            path: 'edit-institutions/:id',
            loadComponent: () =>
              import(
                './features/institutions/pages/edit-institutions/edit-institutions.component'
              ).then((c) => c.EditInstitutionsComponent),
          },
        ],
      },
      {
        path: 'templates',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/templates/pages/templates/templates.component'
              ).then((c) => c.TemplatesComponent),
          },
          {
            path: 'template-creator',
            loadComponent: () =>
              import(
                './features/templates/pages/template-creator/template-creator.component'
              ).then((c) => c.TemplateCreatorComponent),
          },
          {
            path: 'template-editor',
            loadComponent: () =>
              import(
                './features/templates/pages/template-editor/template-editor.component'
              ).then((c) => c.TemplateEditorComponent),
          },
        ],
      },
      {
        path: 'report',
        loadComponent: () => import('./features/dashboard-report/page/main-view/dashboard-report.component').then(
          (c) => c.DashboardReportComponent,
        ),
      },
      {
        path: 'statement-assignment',
        loadChildren: () =>
          import('./features/statement-assignment/pages/statement.routes'),
      },
      {
        path: 'manage-statements',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/manage-statements/pages/manage-statements/manage-statements.component'
              ).then((c) => c.ManageStatementsComponent),
            children: [],
          },
          {
            path: 'form-section/:id/:user_id',
            loadComponent: () =>
              import(
                './features/manage-statements/components/form-section/form-section.component'
              ).then((c) => c.FormSectionComponent),
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './features/users/pages/main-users/main-users.component'
              ).then((c) => c.MainUsersComponent),
          },
          {
            path: 'add-users/:step',
            loadComponent: () =>
              import(
                './features/users/pages/add-users/add-users.component'
              ).then((c) => c.AddUsersComponent),
          },
          {
            path: 'edit-user/:id',
            loadComponent: () =>
              import(
                './features/users/pages/edit-users/edit-users.component'
              ).then((c) => c.EditUsersComponent),
          },
        ],
      },
    ],
  },

  //Leader
  {
    path: 'leader',
    canActivate: [isAuthGuard, isLeaderGuard],
    component: AdminComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/my-profile/my-profile.component').then(
            (c) => c.MyProfileComponent,
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/projects/pages/projects/projects.component').then(
            (c) => c.ProjectsComponent,
          ),
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./features/projects/pages/projects/projects.component').then(
            (c) => c.ProjectsComponent,
          ),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/pages/home/home.component').then(
            (c) => c.HomeComponent,
          ),
      },
      {
        path: 'report',
        loadComponent: () => import('./features/dashboard-report/page/main-view/dashboard-report.component').then(
          (c) => c.DashboardReportComponent,
        ),
      },
    ],
  },

  //Page not found
  {
    path: '**',
    component: PageNotFound404Component,
  },
];
